<ul class="breadcrumb">
  <li *ngFor="let link of breadcrumbs" class="breadcrumb-item">
    <!-- Affichage avec lien actif -->
    <ng-container *ngIf="link.url; else noLink">
      <a [routerLink]="link.url"> {{ link.translate ? (link.label | translate) : link.label }}</a>
    </ng-container> 

    <!-- Affichage sans lien actif -->
    <ng-template #noLink>
      <a> {{ link.translate ? (link.label | translate) : link.label }}</a>
    </ng-template>
  </li>
</ul>
